import { useState, type InputHTMLAttributes } from "react";
import { IconEye, IconEyeOff } from "./icons";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

export function PasswordField(props: Props) {
  const [visible, setVisible] = useState(false);
  return (
    <span className="password-field">
      <input {...props} type={visible ? "text" : "password"} />
      <button
        type="button"
        className="password-toggle"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        tabIndex={-1}
      >
        {visible ? <IconEyeOff /> : <IconEye />}
      </button>
    </span>
  );
}
